import {general} from "../../../../store/action";
import {connect} from "react-redux";
import React from "react";

type PrescriptionBillCardsBoxItemProps = {
    item: any;
    handleShowModal: any;
}

const PrescriptionBillCardsBoxItem = ({
    item,
    handleShowModal
}: PrescriptionBillCardsBoxItemProps) => {

    return (
        <div
            className={'card shadow-none border border-gray-300 rounded-4 my-3 py-3 px-5'}>
            <div
                className={'row row-cols-lg-6 row-cols-md-3 row-cols-2'}>
                <div className={'d-flex align-items-center mb-3'}>
                    <span className={'text-gray ms-3'}>
                        صندوق:
                    </span>
                    <span className={'text-gray-2'}>
                        {item?.productName}
                    </span>
                </div>
                <div className={'d-flex align-items-center mb-3'}>
                    <span className={'text-gray ms-3'}>
                        ویزیت:
                    </span>
                    <span className={'text-gray-2'}>
                        {item?.type?.name}
                    </span>
                </div>
                <div className={'d-flex align-items-center mb-3'}>
                    <span className={'text-gray ms-3'}>
                        هزینه:
                    </span>
                    <span className={'text-gray-2'}>
                        {item?.orgPart || 0}
                    </span>
                </div>
                <div className={'d-flex align-items-center mb-3'}>
                    <span className={'text-gray ms-3'}>
                        سایر خدمات:
                    </span>
                    <span className={'text-gray-2'}>
                        {item?.count}
                    </span>
                </div>
                <div className={'d-flex align-items-center mb-3'}>
                    <span className={'text-gray ms-3'}>
                        هزینه:
                    </span>
                    <span className={'text-gray-2'}>
                        {(item.count && item?.orgPart) ? item?.count * item?.orgPart : '-'}
                    </span>
                </div>
                <div className={'d-flex align-items-center mb-3'}>
                    <span className={'text-gray ms-3'}>
                        سرجمع:
                    </span>
                    <span className={'text-gray-2'}>
                        {(item.count && item?.orgPart) ? item?.count * item?.orgPart + item?.orgPart : '-'}
                    </span>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => ({
    handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PrescriptionBillCardsBoxItem);
